export const UserVisitsStateConstants = {
  FilterStateName: 'userVisitFilter',
  VisitsStateName: 'userVisits',
};

export const UserVisitsActions = {
  SetFilter: 'SET_USER_VISIT_FILTER',
  SetVisits: 'SET_USER_VISITS',
};
